import { css } from 'styled-components';

const epbStyles = css`
  @font-face {
    font-family: 'LL Circular Black Web';
    src: url(${`/fonts/Circular/lineto-circular-black.eot`});
    src:
      url(${`/fonts/Circular/lineto-circular-black.eot?#iefix`}) format('embedded-opentype'),
      url(${`/fonts/Circular/lineto-circular-black.woff2`}) format('woff2'),
      url(${`/fonts/Circular/lineto-circular-black.woff`}) format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Futura Next';
    src: url(${`/fonts/FuturaNext/FuturaNext_Bold.otf`}) format('opentype');
    font-weight: bold;
  }
  @font-face {
    font-family: 'Futura Next';
    src: url(${`/fonts/FuturaNext/FuturaNext_Medium.otf`}) format('opentype');
    font-weight: 500;
  }
`;

export default epbStyles;
